import { render, staticRenderFns } from "./ptcViewFile.vue?vue&type=template&id=4271c319&scoped=true&"
import script from "./ptcViewFile.vue?vue&type=script&lang=js&"
export * from "./ptcViewFile.vue?vue&type=script&lang=js&"
import style0 from "./ptcViewFile.vue?vue&type=style&index=0&id=4271c319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271c319",
  null
  
)

export default component.exports